<template>
  <v-dialog v-model="dialog.status" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <div class="client-form">
      <div class="header">
        <div @click="returnScreen()" class="return-screen">
          <v-icon color="white">mdi-close</v-icon>
        </div>
        <!-- <div @click="returnScreen()" class="delete">
        <v-icon color="white">mdi-delete</v-icon>
      </div> -->
        <h2>Cliente</h2>
        <div>
          {{
            client && client.id ? client.name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase()) : 'Cadastrando cliente'
          }}
        </div>
      </div>
      <div class="content">
        <v-tabs :show-arrows="false" v-model="tab" fixed-tabs align-with-title background-color="#F5F5F5" color="#48B38B">
          <v-tabs-slider color="#48B38B"></v-tabs-slider>
          <v-tab>
            <v-icon>mdi-account</v-icon>
          </v-tab>
          <v-tab>
            <v-icon>mdi-car</v-icon>
          </v-tab>
          <v-tab>
            <v-icon>mdi-map-marker-radius</v-icon>
          </v-tab>
          <v-tab>
            <v-icon>mdi-poll</v-icon>
          </v-tab>
        </v-tabs>
      </div>
      <div class="form-content">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-radio-group v-model="client.gender" :disabled="loading" class="mt-0" row>
              <v-radio label="Masculino" value="male"></v-radio>
              <v-radio label="Feminino" value="female"></v-radio>
              <v-radio label="PJ" value="company"></v-radio>
            </v-radio-group>
            <v-text-field
              v-model="client.name"
              :disabled="loading"
              color="#777"
              label="*Nome Completo"
              class="pb-4 mt-2"
              hide-details
              outlined
            ></v-text-field>
            <v-text-field
              v-model="client.phone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :disabled="loading"
              color="#777"
              label="*Celular principal"
              class="pb-4"
              hide-details
              outlined
            ></v-text-field>
            <v-select
              v-model="client.client_classification_id"
              :items="client_classifications"
              :disabled="loading"
              item-text="description"
              item-value="id"
              label="*Classificação"
              class="pb-4"
              color="#777"
              outlined
              hide-details
            ></v-select>
            <v-text-field
              v-model="client.cpf_cnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              :disabled="loading"
              label="CPF ou CNPJ"
              class="pb-4"
              color="#777"
              hide-details
              outlined
            ></v-text-field>
            <v-text-field
              v-if="client.gender !== 'company'"
              v-model="client.birthdate"
              :disabled="loading"
              v-mask="['##/##/####']"
              color="#777"
              label="Data de nascimento"
              class="pb-4"
              hide-details
              outlined
            ></v-text-field>
            <v-text-field
              v-if="client.gender !== 'company'"
              v-model="client.profession"
              :disabled="loading"
              color="#777"
              label="Profissão"
              class="pb-4"
              hide-details
              outlined
            ></v-text-field>

            <div v-if="client.gender === 'company'" class="pb-4 password-div">
              <v-text-field
                v-model="client.password"
                @click:append="show_password = !show_password"
                :disabled="loading"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                color="#777"
                label="Senha de acesso do relatório"
                hide-details
                outlined
              ></v-text-field>

              <v-tooltip v-if="client?.have_password" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-3" color="#48B38B" v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
                </template>
                <span>Senha cadastrada! Para alterar digite no campo ao lado</span>
              </v-tooltip>

              <v-tooltip v-if="client?.have_password" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon class="ml-3" v-bind="attrs" v-on="on" @click="removePassword"><v-icon color="#ff6347">mdi-delete</v-icon></v-btn>
                </template>
                <span>Remover senha do usuário</span>
              </v-tooltip>
            </div>
            <!-- <div class="label-separator">
            Endereços:
          </div>
          <div v-for="address in client.client_addresses" :key="address.id" class="context-container client-address mb-3">
            <div class="client-content">
              <div class="address-locale"><b>{{ address.description }}</b> {{ address.locale }}</div>
            </div>
            <div @click="removeAddress(address)" class="address-remove">
              <v-icon
                size="40"
                color="red"
              >mdi-close-box</v-icon>
            </div>
          </div> -->
            <v-btn @click="client.id ? saveClient() : saveClient()" :loading="loading" color="#48B38B" dark block depressed large>Salvar</v-btn>
          </v-tab-item>
          <v-tab-item>
            <v-alert color="#48B38B" dark border="left"> Funcionalidade de editar <b>veículos</b> do cliente estará disponível em breve. </v-alert>
          </v-tab-item>
          <v-tab-item>
            <v-alert color="#48B38B" dark border="left"> Funcionalidade de editar <b>endereços</b> do cliente estará disponível em breve. </v-alert>
          </v-tab-item>
          <v-tab-item>
            <v-alert color="#48B38B" dark border="left"> <b>Gráficos e indicadores</b> do cliente estarão disponíveis em breve. </v-alert>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClientForm',
  props: {
    dialog: Object
  },
  data: () => ({
    tab: 0,
    loading: false,
    show_password: false,
    client: {
      birthdate: null,
      client_addresses: null,
      client_classification: null,
      client_classification_id: null,
      cpf_cnpj: null,
      created_at: null,
      gender: null,
      id: null,
      name: null,
      phone: null,
      profession: null,
      service_orders_count: null,
      service_orders_last: null,
      type: null,
      password: undefined
    },
    client_classifications: []
  }),
  mounted() {
    this.getClassificationList();
    if (this.dialog.client) {
      const { password, ...data } = this.dialog.client;
      this.client = data;
      if (this.client.birthdate) {
        const splited = this.client.birthdate.split('-');
        this.client.birthdate = `${splited[2]}/${splited[1]}/${splited[0]}`;
      }
    }
  },
  methods: {
    getClassificationList() {
      const self = this;
      self.$http
        .get('/client/classifications', {
          params: {
            size: 999
          }
        })
        .then((response) => {
          self.client_classifications = response.data.rows;
        });
    },
    saveClient() {
      const self = this;
      self.loading = true;
      self.$http
        .patch(`/client/${self.client.id}/update`, self.client)
        .then(() => {
          self.loading = false;

          if (this.client.password) {
            this.client.have_password = 1;
            this.client.password = undefined;
          }
        })
        .catch(() => {
          self.loading = false;
        });
    },
    returnScreen() {
      this.$emit('return', this.client);
    },
    removePassword() {
      this.client.have_password = 0;
      this.client.password = null;
    }
  }
};
</script>

<style lang="scss">
.client-form {
  background-color: #fff;

  .header {
    position: fixed;
    width: 100%;
    z-index: 99;
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }

    .delete {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
      margin-right: 10px;
    }
  }

  .content {
    margin-top: 100px;
  }

  .form-content {
    padding: 20px;

    .theme--light.v-tabs-items {
      background-color: inherit !important;
    }

    .client-address {
      overflow: hidden;

      .address-remove {
        float: left;
        border-left: 1px solid #777;
        margin-top: 5px;
        padding-left: 5px;
        margin-left: 5px;
      }

      .client-content {
        float: left;
        width: calc(100% - 55px);

        .address-description {
          font-size: 18px;
        }

        .address-locale {
          font-size: 15px;

          b {
            font-size: 17px;
          }
        }
      }
    }
  }

  .v-tabs--fixed-tabs > .v-tabs-bar .v-tab {
    margin-left: 0px !important;
  }

  .v-slide-group__prev,
  .v-slide-group__next {
    display: none !important;
  }
}

.password-div {
  display: flex;
  align-items: center;
}
</style>
